module.exports = __webpack_public_path__ + "static/media/er.b4ea80f7.svg";